import React, { Component } from 'react'
import { Container, Row, Col, Tabs, Tab } from 'react-bootstrap'
import Footer from './Footer'
import HeaderTop from './HeaderTop'
import SideNavTop from './SideNavTop'
import '../Accueil.css'


class Synchro extends Component {
    state = {
        redirect: false,
        search: '',
        key: 'maitre'
    }

    handleCHange = event => {
        const { name, value } = event.target
        this.setState({ [name]: value })
    }

    handleSubmit = event => {
        //on gere le form
        event.preventDefault()
        this.props.history.push(`/recherche/${this.state.search}`);

    }

    setRedirect = () => {
        this.setState({
          redirect: true
        })
      }

    handleSubmitFacebbok = () => {
        if (this.state.redirect) {
            window.location.href = "https://www.facebook.com/clubCAPN/";
        }
    }

    handleSelect(key) {
        if (key === "maitre")
            this.props.history.push(`/competiton/maitres-nageurs`);
        else if (key === "natation")
            this.props.history.push(`/competiton/natation`);
        else if (key === "sauvetage")
            this.props.history.push(`/competiton/sauvetage-sportif`);
        else if (key === "resultat")
            this.props.history.push(`/competiton/resultats`);
        else if (key === "synchro")
            this.props.history.push(`/competiton/nage-synchronisee`);
    }

    render() {
        console.log(this.state.key)
        return (
            <>
                <Container fluid>
                <Row>
            <SideNavTop/>
            <Col lg={10} md={12} sm={12} xs={12} id="page-content-wrapper" className="nopadding">
              <HeaderTop
                handleSubmit={this.handleSubmit}
                handleCHange={this.handleCHange}
                handleSubmitFacebbok={this.handleSubmitFacebbok}
                setRedirect={this.setRedirect}
              />

                            <Col lg={12} md={12} sm={12} xs={12} className="nopadding">

                                <Tabs
                                    id="controlled-tab"
                                    activeKey={this.state.key}
                                    onSelect={key => this.handleSelect(key)}
                                >                       <Tab eventKey="maitre" title="Maître Nageurs">
                                    </Tab>
                                    <Tab eventKey="synchro" title="Nage synchronisée">
                                    </Tab>
                                    <Tab eventKey="natation" title="Natation" >
                                    </Tab>
                                    <Tab eventKey="sauvetage" title="Sauvetage sportif">
                                    </Tab>
                                    <Tab eventKey="resultat" title="Résultats des compétitions" >
                                    </Tab>
                                </Tabs>
                            </Col>


                            <Col lg={12} md={12} sm={12} xs={12} className="nopadding">
                                <Row>
                                    <Col lg={12} md={12} sm={12} xs={12} className="nopadding">
                                        <div className="histoire-content">
                                            <h1><span>Nage synchronisée junior et senior - Saison 2020-2021</span></h1>
                                            <p className="pCenter">La nage synchronisée revient au club CAPN pour l'année 2020-2021! Nous avons très hâte de partager ce beau sport avec vous!<br />
 
                                            Inscriptions: A partir du 2 Septembre 2020<br />
                                            Début de l'entraînement : 19 septembre 2020<br />
                                            Prendre note qu'il y aura arrêt des entraînements pour la période des fêtes du 19 décembre 2020 au 3 janvier 2021 inclusivement ainsi que durant la semaine de relâche.
                                            Pour des informations supplémentaires veuillez communiqué par courriel avec l'entraîneur-chef au <strong>synchrocapn@gmail.com</strong><br /><br />
                                            </p>
                                            <h3>JUNIOR  - 5 heures d'entrainement par semaine</h3>
                                            
                                            <p className="pCenter"> Pré-requis : Junior 5 complété<br />
                                            <strong>Coût :</strong> 580 $ + affiliation obligatoire-50$<br />
                                            Frais de compétition obligatoire :160$ <br />
                                            <strong>Durée :</strong> 12 septembre 2020 au 19 juin 2021<br />
                                            </p>

                                            <h3>SENIOR  - 5 heures d'entrainement par semaine</h3>
                                            <p className="pCenter"><strong>Coût :</strong> 580 $ + affiliation obligatoire-30$<br />
                                            <strong>Durée :</strong> 12 septembre 2020 au 19 juin 2021<br /></p>

                                                                                        
                                            <h2>HORAIRE D'ENTRAINEMENT- junior( 4h/semaine)</h2>
                                            <p className="pCenter">Mercredi de 17h30 à 19h30<br />
                                            Samedi  de 8h00 à 11h00</p>
                                            
                                            <h2>HORAIRE D'ENTRAINEMENT- senior( 5h/semaine)</h2>
                                            <p className="pCenter">Mercredi de 17h30 à 19h30<br />
                                            Dimanche de 17h30 à 20h30</p>

                                            <div className="pCenter">
                                                <p className="pCenter"> Lien<br/></p> <a className="link-history" href="https://www.fnq.qc.ca">Fédération de natation du Québec</a><br/>
                                                <a className="link-history" href="https://www.mymsc.ca">Maîtres-nageurs du Canada</a>
                                            </div>
                                        </div>
                                    </Col>
                                </Row>
                            </Col>

                            <Col lg={12} md={12} sm={12} xs={12} className="nopadding">
                                <Footer />
                            </Col>
                        </Col>
                    </Row>
                </Container>
            </>
        )
    }
}

export default Synchro
